// extracted by mini-css-extract-plugin
export default {"cards-wrap":"g__cards-wrap--avhAC"};